import { render } from "./editor.vue?vue&type=template&id=6348c8df&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"

import "./editor.vue?vue&type=style&index=0&id=6348c8df&lang=less&scoped=true"
import "./editor.vue?vue&type=style&index=1&id=6348c8df&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6348c8df"]])

export default __exports__